import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@/components/Base/Tooltip';

import { ProductCompanyRatingValue, Wrapper } from './CardRating.styles';

function CardRating({
  position,
  children = null,
  tooltipProps = {},
  rating = '0',
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const showEvents = ['mouseenter', 'touchend'];
  const hideEvents = ['mouseleave'];

  const toggleTooltip = (isShow = null) => {
    setShowTooltip((prevShowTooltip) =>
      isShow !== null ? isShow : !prevShowTooltip
    );
  };

  return (
    <Wrapper data-tip-target>
      <ProductCompanyRatingValue value={rating} />

      <Tooltip
        show={showTooltip}
        position={position}
        toggle={toggleTooltip}
        showEvents={showEvents}
        hideEvents={hideEvents}
        {...tooltipProps}
      >
        <div>{children}</div>
      </Tooltip>
    </Wrapper>
  );
}

CardRating.propTypes = {
  children: PropTypes.node,
  rating: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']).isRequired,
  tooltipProps: PropTypes.objectOf(PropTypes.any),
};

export default memo(CardRating);
